import { Flex, FlexProps, useBreakpoint } from "@biblioteksentralen/react";
import { getContainerQuery } from "../../site/banners/promotedItems/utils";
import { ChristmasPresent, ChristmasPresentColor, christmasPresentColors } from "../ChristmasPresent/ChristmasPresent";
import { Breakpoint } from "../../../utils/chakraUtils";

// Presents from left end to right and then from right to left
const christmasPresentProps: (Omit<FlexProps, "animationDuration"> & { animationDelay: string })[] = [
  {
    animationDelay: "0s",
  },
  {
    animationDelay: ".5s",
    transform: "translate(-25%, 30%) rotate(10deg)",
  },
  {
    animationDelay: ".75s",
    marginLeft: "auto",
    transform: "translate(50%, 0)",
  },
  {
    animationDelay: ".3s",
    transform: "translate(10%, 30%) rotate(-15deg)",
  },
  {
    animationDelay: "1.2s",
    transform: "translate(-10%, -10%)",
  },
];

const defaultColors: ChristmasPresentColor[] = [
  christmasPresentColors[1],
  christmasPresentColors[2],
  christmasPresentColors[4],
  christmasPresentColors[6],
  christmasPresentColors[2],
];

type Props = {
  presentColors?: ChristmasPresentColor[];
  hovered: boolean;
  hidePresentsBelow?: Breakpoint;
};

export const Presents = (props: Props) => {
  const breakpoint = useBreakpoint();

  const animationPlayState = breakpoint && !["base", "sm"].includes(breakpoint) && props.hovered ? "running" : "paused";

  return (
    <Flex
      hideBelow={props.hidePresentsBelow}
      paddingTop=".4em"
      css={getContainerQuery({
        base: { fontSize: "3xl" },
        sm: { fontSize: "6xl" },
        lg: { fontSize: "8xl" },
      })}
      gap=".1em"
      pointerEvents="none"
      marginBottom="-.65em"
    >
      {(props.presentColors ?? defaultColors)?.map((colors, index) => (
        <ChristmasPresent
          {...colors}
          {...christmasPresentProps[index]}
          key={index}
          width="1.25em"
          height="1em"
          animationPlayState={animationPlayState}
        />
      ))}
    </Flex>
  );
};
